
import appConfig from '../app-config';

export const logInfo = (message, ...optionalParams) => {
  if (appConfig.environment === 'local' || appConfig.environment === 'development')
    console.log(message, ...optionalParams);
};

export const logError = (error, ...optionalParams) => {
  if (appConfig.environment === 'local' || appConfig.environment === 'development')
    console.error(error, ...optionalParams);
};

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file)
    fileReader.onload = () => {
      resolve(fileReader.result);
    }
    fileReader.onerror = (error) => {
      reject(error);
    }
  })
}